import { Input } from "antd";
import SpLabel from "../SpLabel/SpLabel";

const SpInput = ({ 
  label, 
  htmlFor, 
  id, 
  placeholder, 
  onChange, 
  onBlur,
  value,
  type = "text",
  required = false,
  error,
  disabled = false,
  className = "",
  ...otherProps 
}) => {
  const inputId = label ? htmlFor : id;
  const inputClassName = `sp-input ${className} ${error ? 'sp-input-error' : ''}`.trim();
  
  return (
    <div className="sp-input-wrapper">
      {label && (
        <SpLabel htmlFor={htmlFor}>
          {label}
          {required && <span style={{ color: '#ff4d4f', marginLeft: '2px' }}>*</span>}
        </SpLabel>
      )}
      <Input
        id={inputId}
        className={inputClassName}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        type={type}
        disabled={disabled}
        status={error ? 'error' : undefined}
        {...otherProps}
      />
      {error && (
        <div className="sp-input-error-message" style={{ 
          color: '#ff4d4f', 
          fontSize: '12px', 
          marginTop: '4px',
          lineHeight: '1.4'
        }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default SpInput;